export default __webpack_public_path__ + "static/media/ipX0.0ef503e1.svg";